import { JDSFooterLinksProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSFooterLinksProps>
  ): React.FC<JDSFooterLinksProps> =>
  (props: JDSFooterLinksProps) => {
    return <Component {...props} />;
  };
